import * as React from 'react';

import {QuoteRichTextDisplay} from './quote-rich-text-display';

type Props = {
    text: string;
    placeholder?: string;
};

export function QuoteNoteSection(props: Props) {
    const {placeholder = 'Add any important information here for your recipient'} = props;

    return (
        <div className='full-height full-width truncate word-break'>
            <QuoteRichTextDisplay text={props.text} placeholderText={placeholder} />
        </div>
    );
}
